import { MetaConversation } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import {
  getCurrentOutboundPhoneLoad,
  getPhoneCallAvailability,
} from 'components/telephony/utils/phoneCallAvailability';

import { actions } from '../../../telephony/actions/telephony';
import { TelephonyTopbarButton } from '../components/telephonyTopbarButton';

const mapStateToProps = (state: RootReducerStateT) => {
  // Compute availability + tooltip + the active phone load once. SearchUser
  // is rendered inside this button and reuses the same values via OwnProps,
  // so doing it here keeps the gate, loading flag, and tooltip in lockstep
  // and avoids re-running the lookup in two containers.
  const {
    canMakePhoneCall: canMakeOutBoundCall,
    isResolvingDefaultNumber,
    phoneCallDisabledTooltipText,
    selectedFromNumber,
  } = getPhoneCallAvailability(state, {
    // The topbar dialer (and the SearchUser dropdown beneath it) treats consumed
    // callback loads as non-blocking when deciding whether the agent can dial out.
    allowConsumedCallbackLoads: true,
  });

  const activePhoneLoad = getCurrentOutboundPhoneLoad(state, {
    allowConsumedCallbackLoads: true,
  });

  const isInternalCall = activePhoneLoad?.load_type === 'internalwork';

  // Walking metaConversations is a defensive lookup against an upstream-shaped
  // array; if it ever throws we still want the rest of the props to render
  // (`activePhoneMetaConversation` just stays null) but we must NOT flip the
  // call-availability gate as a side effect of catching here.
  let activePhoneMetaConversation: MetaConversation | null = null;
  if (activePhoneLoad) {
    try {
      for (const metaConversation of state.conversations.metaConversations) {
        if (
          metaConversation.conversation.is_closed === false &&
          metaConversation.isAssignedToMe === true &&
          (metaConversation.conversation.initial_channel === 'pstnphone' ||
            metaConversation.conversation.initial_channel === 'callback')
        ) {
          activePhoneMetaConversation = metaConversation;
          break;
        }
      }
    } catch (exception) {
      console.error(exception);
    }
  }

  return {
    isInternalCall,
    canMakeOutBoundCall,
    isResolvingDefaultNumber,
    phoneCallDisabledTooltipText,
    isTelephonyDropdownOpen: state.telephony.ui.isTelephonyDropdownOpen,
    selectedFromNumber,
    users: state.telephony.users,
    activePhoneMetaConversation,
    defaultNumber:
      state.settings.organization.organization.default_outbound_number,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    telephonyOpenDropdown: () => dispatch(actions.telephonyOpenDropdown()),
    telephonyCloseDropdown: () => dispatch(actions.telephonyCloseDropdown()),
  };
};

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

export default connect<StateProps, DispatchProps, unknown, RootReducerStateT>(
  mapStateToProps,
  mapDispatchToProps,
)(TelephonyTopbarButton);
